import React from "react";
import { Button, Form, Flex, Row, Col } from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import { RequestAtc } from "../redux/apiSlice/requestSlice";
import { denyRequest } from "../redux/apiActions/requestsAction";
import { useAppDispatch } from "../redux/hooks";

type Props = {
  record: RequestAtc;
  popup: any;
};

const DenyRequestForm: React.FC<Props> = ({ record, popup }: Props) => {
  const [form] = useForm();

  const dispatch = useAppDispatch();
  const onFinish = async (values: any) => {
    const res = await dispatch(
      denyRequest({ request_id: record.id, ...values })
    );
    if (res.payload.status === "ok") {
      popup.close();
    }
  };

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        initialValues={record}
        onFinish={onFinish}
      >
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col span={18}>
            <Form.Item
              label="What is your reason for denying the request briefly?"
              name="reason"
              rules={[{ required: true, message: "Reason is required" }]}
            >
              <TextArea rows={5} />
            </Form.Item>

            <Flex justify={"center"}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  ghost
                  // loading={loading.createExam || loading.updateExam}
                  // disabled={loading.createExam || loading.updateExam}
                >
                  Submit
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default DenyRequestForm;
